export default __webpack_public_path__ + "static/media/17-min.7ff6a91c.jpg";